/* Custom Suit - Customization UI v1 */
(function() {
  var OW_CDN = 'https://d49ohm0ne1s0e.cloudfront.net/modules/eshop3/options';

  /* -- Companion product: "Full Canvas Upgrade" ($100).
        Auto-added to cart when customer selects Full Canvas construction. -- */
  var FULL_CANVAS_VARIANT_ID = 52194296398117;
  var FULL_CANVAS_UPCHARGE_LABEL = '+$100';

  /* -- Bundle id: a short random token attached to the suit line item (and
        its companion upgrade if any) so we can find and remove both lines
        when the customer edits a customized suit. -- */
  function csNewBundleId() {
    return 'b' + Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4);
  }
  var __csCurrentBundleId = csNewBundleId();

  /* -- When a Horizon product form is submitted (Add to Cart) and Full
        Canvas is selected, fire a separate /cart/add.js for the upgrade
        companion product. We use a capture-phase 'submit' listener on
        document so we run before Horizon's own handler — and we don't
        depend on intercepting fetch (Horizon/Shopify wrap window.fetch
        with their own wrapper, breaking direct hooks). -- */
  (function installCanvasUpgradeSubmitListener() {
    if (window.__csCanvasSubmitHook) return;
    window.__csCanvasSubmitHook = true;

    function postUpgrade(qty, bundleId) {
      // Returns a promise so callers can chain strictly serial work.
      try {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            id: FULL_CANVAS_VARIANT_ID,
            quantity: qty || 1,
            properties: { '_Bundled With': 'Suit — Full Canvas Upgrade', '_bundle_id': bundleId }
          })
        }).catch(function(){});
      } catch (e) { return Promise.resolve(); }
    }

    function removeOldBundle(oldBundleId) {
      try {
        return fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
          var updates = {};
          var found = false;
          (cart.items || []).forEach(function(it){
            var bid = it.properties && (it.properties._bundle_id || it.properties['_bundle_id']);
            if (bid === oldBundleId) { updates[it.key] = 0; found = true; }
          });
          if (!found) return;
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: {'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify({updates: updates})
          }).then(function(){
            try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch(e){}
            try { document.dispatchEvent(new CustomEvent('cart-update')); } catch(e){}
          }).catch(function(){});
        }).catch(function(){});
      } catch (e) { return Promise.resolve(); }
    }

    // Poll /cart.js until a cart item with the given _bundle_id and a non-
    // upgrade variant appears, or until timeout. Horizon's /cart/add.js can
    // take several seconds to resolve on slow connections, and we must NOT
    // fire the upgrade add or remove-old-bundle until the new suit is
    // actually present — otherwise reconcile can see transient inconsistent
    // states and incorrectly flip the suit's canvas option.
    function waitForSuitInCart(bundleId, timeoutMs) {
      var deadline = Date.now() + (timeoutMs || 8000);
      return new Promise(function(resolve){
        function check() {
          fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
            var hit = (cart.items || []).some(function(it){
              var bid = it.properties && (it.properties._bundle_id || it.properties['_bundle_id']);
              return bid === bundleId && it.variant_id !== FULL_CANVAS_VARIANT_ID;
            });
            if (hit) return resolve(true);
            if (Date.now() >= deadline) return resolve(false);
            setTimeout(check, 150);
          }).catch(function(){
            if (Date.now() >= deadline) return resolve(false);
            setTimeout(check, 200);
          });
        }
        check();
      });
    }

    var __csLastSubmitTs = 0;
    function handleFormSubmit(form) {
      try {
        if (!form || !form.querySelector) return;
        var idEl = form.querySelector('input[name="id"]');
        if (!idEl) return;
        // Dedupe — click + submit may both fire within milliseconds
        var now = Date.now();
        if (now - __csLastSubmitTs < 500) return;
        __csLastSubmitTs = now;

        // Generate a fresh bundle id for THIS add and stamp it on the form
        __csCurrentBundleId = csNewBundleId();
        var bidInput = form.querySelector('input[name="properties[_bundle_id]"]');
        if (!bidInput) {
          bidInput = document.createElement('input');
          bidInput.type = 'hidden';
          bidInput.name = 'properties[_bundle_id]';
          form.appendChild(bidInput);
        }
        bidInput.value = __csCurrentBundleId;

        var qty = 1;
        var qEl = form.querySelector('[name="quantity"]');
        if (qEl && qEl.value) qty = parseInt(qEl.value, 10) || 1;

        var bid = __csCurrentBundleId;
        var canvas = window.__csSelections && window.__csSelections.canvas;
        var oldBid = window.__csReplaceBundle || null;
        if (oldBid) window.__csReplaceBundle = null;

        // Mark the cart as "mid add". Reconcile will early-return while this
        // is truthy — Horizon's own /cart/add.js POST can take 2+ seconds on
        // slow networks, and during that window the cart is inconsistent
        // (upgrade present, suit not yet added). Without this guard the
        // reconcile triggered by post-add cart events sees an "orphaned"
        // upgrade and removes it, then sees an "orphaned Full Canvas suit"
        // once the suit finally lands, and flips it to Half Canvas.
        window.__csAddInFlight = bid;
        window.__csCartDirty = true;

        // Serialize: wait for Horizon's suit add to LAND in the cart, then
        // post the upgrade (if Full Canvas), then remove the old edited
        // bundle (if any). Only after all three complete do we clear the
        // in-flight flag and allow reconcile to run again.
        waitForSuitInCart(bid, 10000).then(function(){
          if (canvas === 'Full Canvas') return postUpgrade(qty, bid);
        }).then(function(){
          if (oldBid) return removeOldBundle(oldBid);
        }).then(function(){
          window.__csAddInFlight = null;
          window.__csCartDirty = false;
          try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch(e){}
          try { document.dispatchEvent(new CustomEvent('cart-update')); } catch(e){}
        }, function(){
          window.__csAddInFlight = null;
          window.__csCartDirty = false;
        });
      } catch (e) {}
    }

    document.addEventListener('submit', function(ev) {
      var t = ev.target;
      if (t && t.tagName === 'FORM') handleFormSubmit(t);
    }, true);

    // Belt-and-braces: also intercept clicks on Add to Cart buttons.
    document.addEventListener('click', function(ev) {
      try {
        var el = ev.target;
        if (!el || !el.closest) return;
        var btn = el.closest('add-to-cart-component, button[type="submit"], .add-to-cart-button');
        if (!btn) return;
        var form = btn.closest('form');
        if (form) handleFormSubmit(form);
      } catch (e) {}
    }, true);
  })();

  /* -- Cart edit-link injection. Adds an "Edit" link under each customized
        suit line item (in both /cart page and the cart drawer) that returns
        the customer to the product page with their selections preloaded. -- */
  (function installCartEditLinks() {
    if (window.__csCartEditInstalled) return;
    window.__csCartEditInstalled = true;

    function buildEditUrl(item) {
      try {
        var props = item.properties || {};
        var bundleId = props._bundle_id || props['_bundle_id'];
        if (!bundleId) return null;
        // Strip variant query, build base
        var base = (item.url || '').split('?')[0];
        if (!base) return null;
        var qs = ['edit=' + encodeURIComponent(bundleId)];
        Object.keys(props).forEach(function(k){
          if (k.charAt(0) === '_') return; // skip private
          // Map property name -> step id or group id
          var stepId = NAME_TO_STEP_ID[k];
          var groupId = NAME_TO_GROUP_ID[k];
          if (stepId) {
            qs.push('p_' + stepId + '=' + encodeURIComponent(props[k]));
          } else if (groupId) {
            // Checkbox groups: stored as comma-separated names. Use | as separator
            // in URL to avoid commas being escaped.
            var v = (props[k] || '').split(', ').join('|');
            qs.push('c_' + groupId + '=' + encodeURIComponent(v));
          }
        });
        // Preserve variant if present
        if (item.variant_id) qs.push('variant=' + item.variant_id);
        // Include the variant option values directly (e.g. ["44R","36","30"]),
        // since /products/handle.js is capped at 250 variants and a suit has
        // more — looking up by variant_id fails silently on large products.
        if (item.variant_options && item.variant_options.length) {
          qs.push('sizes=' + encodeURIComponent(item.variant_options.join('|')));
        }
        return base + '?' + qs.join('&');
      } catch (e) { return null; }
    }

    function injectIntoRow(tr, item, url) {
      if (!tr || tr.querySelector('.cs-cart-edit-link')) return;
      // Find the details td
      var details = tr.querySelector('.cart-items__details') || tr.querySelector('td');
      if (!details) return;
      var a = document.createElement('a');
      a.className = 'cs-cart-edit-link';
      a.href = url;
      a.textContent = 'Edit customizations';
      details.appendChild(a);
    }

    function applyToContainer(root) {
      try {
        fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
          (cart.items || []).forEach(function(item){
            var bid = item.properties && (item.properties._bundle_id || item.properties['_bundle_id']);
            if (!bid) return;
            // Skip the companion upgrade itself
            if (item.variant_id === FULL_CANVAS_VARIANT_ID) return;
            var url = buildEditUrl(item);
            if (!url) return;
            // Find the matching tr by data-key in the given root (or document)
            var scope = root || document;
            var tr = scope.querySelector('tr[data-key="' + item.key + '"]');
            if (tr) injectIntoRow(tr, item, url);
          });
        }).catch(function(){});
      } catch (e) {}
    }

    // Build name→id maps once STEPS/MORE_OPTIONS are defined
    var NAME_TO_STEP_ID = {};
    var NAME_TO_GROUP_ID = {};
    function buildMaps() {
      if (typeof STEPS === 'undefined') return false;
      STEPS.forEach(function(s){ NAME_TO_STEP_ID[s.name] = s.id; });
      MORE_OPTIONS.forEach(function(g){ NAME_TO_GROUP_ID[g.name] = g.id; });
      return true;
    }

    function run() {
      if (!buildMaps()) { setTimeout(run, 200); return; }
      applyToContainer(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }

    // Re-apply when cart drawer opens or cart updates
    var reapply = function(){ setTimeout(function(){ applyToContainer(document); }, 100); };
    document.addEventListener('cart:refresh', reapply);
    document.addEventListener('cart-update', reapply);
    document.addEventListener('cart:updated', reapply);

    // Watch for cart drawer open via attribute mutations
    setTimeout(function(){
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer) {
        var mo = new MutationObserver(function(){ reapply(); });
        mo.observe(drawer, {childList: true, subtree: true, attributes: true});
      }
      // Also watch the cart-items table for re-renders
      var table = document.querySelector('.cart-items, cart-items-component');
      if (table) {
        var mo2 = new MutationObserver(function(){ reapply(); });
        mo2.observe(table, {childList: true, subtree: true});
      }
    }, 500);
  })();

  /* -- Cart bundle sync. Keeps a suit and its Full Canvas Upgrade in lockstep:
          - If the upgrade is removed but the suit still has Canvas Construction:
            Full Canvas, flip the suit to Half Canvas (re-add with new props,
            remove the old line — properties are part of the line key so you
            can't mutate them in place).
          - If the suit is removed but its companion upgrade still exists,
            remove the orphaned upgrade.
        A reentrancy flag guards against the add/remove cycle re-triggering. -- */
  (function installCartBundleSync() {
    if (window.__csCartSyncInstalled) return;
    window.__csCartSyncInstalled = true;
    var UPGRADE_ID = 52194296398117; // Full Canvas Upgrade variant id
    var busy = false;

    function post(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify(body)
      }).then(function(r){ return r.json(); });
    }

    function notifyCartRefresh() {
      try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch(e){}
      try { document.dispatchEvent(new CustomEvent('cart-update')); } catch(e){}
      try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch(e){}
      // Horizon's cart-drawer-component listens to these; also force a native
      // refetch of any cart renderer by dispatching a 'cart:change' event.
      try { document.dispatchEvent(new CustomEvent('cart:change')); } catch(e){}
    }

    function reconcile() {
      if (busy) {
        // Return the in-flight promise if one exists so callers can await it
        return window.__csReconcileInFlight || Promise.resolve();
      }
      // Never reconcile while an add-to-cart is in flight. See handleFormSubmit:
      // the window between Horizon's suit POST and our upgrade POST is a known
      // transient inconsistent state and must not be "fixed".
      if (window.__csAddInFlight) return Promise.resolve();
      busy = true;
      var p = fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
        var items = cart.items || [];

        // Build bundle_id -> {suit, upgrade} map
        var bundles = {};
        items.forEach(function(it){
          var bid = it.properties && (it.properties._bundle_id || it.properties['_bundle_id']);
          if (!bid) return;
          if (!bundles[bid]) bundles[bid] = {};
          if (it.variant_id === UPGRADE_ID) bundles[bid].upgrade = it;
          else bundles[bid].suit = it;
        });

        var tasks = [];

        Object.keys(bundles).forEach(function(bid){
          var b = bundles[bid];
          // Orphaned upgrade: upgrade without its suit → remove upgrade
          if (b.upgrade && !b.suit) {
            tasks.push(function(){
              var upd = {}; upd[b.upgrade.key] = 0;
              return post('/cart/update.js', {updates: upd});
            });
            return;
          }
          // Suit says Full Canvas but upgrade is gone → flip suit to Half Canvas
          if (b.suit && !b.upgrade) {
            var suitProps = b.suit.properties || {};
            var canvasPropName = 'Canvas Construction';
            if ((suitProps[canvasPropName] || '').indexOf('Full Canvas') !== -1) {
              // Build new properties: clone, override canvas
              var newProps = {};
              Object.keys(suitProps).forEach(function(k){ newProps[k] = suitProps[k]; });
              newProps[canvasPropName] = 'Half Canvas';
              // Keep same bundle_id so edit link etc still work
              tasks.push(function(){
                // Add the new suit line first, then remove the old one.
                return post('/cart/add.js', {
                  id: b.suit.variant_id,
                  quantity: b.suit.quantity,
                  properties: newProps
                }).then(function(){
                  var upd = {}; upd[b.suit.key] = 0;
                  return post('/cart/update.js', {updates: upd});
                });
              });
            }
          }
        });

        if (tasks.length === 0) { busy = false; return; }

        // Run tasks sequentially so the cart is consistent at each step
        var chain = Promise.resolve();
        tasks.forEach(function(t){ chain = chain.then(t); });
        return chain.then(function(){
          busy = false;
          notifyCartRefresh();
        }).catch(function(){ busy = false; });
      }).catch(function(){ busy = false; });
      window.__csReconcileInFlight = p.then(function(){
        window.__csReconcileInFlight = null;
      }, function(){ window.__csReconcileInFlight = null; });
      return window.__csReconcileInFlight;
    }

    // Expose a "settle the cart before checkout" helper.
    window.__csReconcileNow = function () { return reconcile(); };

    // Debounce — cart events can fire in bursts
    var pending = null;
    function schedule() {
      if (pending) clearTimeout(pending);
      pending = setTimeout(function(){ pending = null; reconcile(); }, 250);
    }

    document.addEventListener('cart:refresh', schedule);
    document.addEventListener('cart-update', schedule);
    document.addEventListener('cart:updated', schedule);
    document.addEventListener('cart:change', schedule);

    // Watch cart DOM for mutations (drawer, /cart page table)
    function attachObservers() {
      var targets = [
        document.querySelector('cart-drawer-component'),
        document.querySelector('.cart-items'),
        document.querySelector('cart-items-component')
      ].filter(Boolean);
      targets.forEach(function(t){
        try {
          var mo = new MutationObserver(function(){ schedule(); });
          mo.observe(t, {childList: true, subtree: true});
        } catch(e){}
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function(){ setTimeout(attachObservers, 300); });
    } else {
      setTimeout(attachObservers, 300);
    }

    // One pass on install in case the page loaded with an already-inconsistent cart
    setTimeout(schedule, 500);

    /* -- Fetch wrapper: make cart mutations atomic at the source.
          When Shopify (or any cart UI) POSTs to /cart/change.js or
          /cart/update.js to remove the Full Canvas Upgrade line, we chain
          the suit-flip (Full Canvas → Half Canvas) onto the same promise
          BEFORE resolving. The cart UI's own loading state naturally covers
          our extra work, so there's no perceived delay and no race:
          by the time the "remove" visual completes, the suit has already
          been updated. Checkout can be clicked immediately after. -- */
    if (!window.__csFetchWrapped) {
      window.__csFetchWrapped = true;
      var origFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var method = (init && init.method) || (typeof input !== 'string' && input && input.method) || 'GET';
        // Only intercept REMOVAL-type mutations. /cart/add.js is excluded
        // because the add-suit flow does two sequential POSTs (suit, then
        // Full Canvas Upgrade companion) — reconciling between them would
        // see the suit as "orphaned Full Canvas" and flip it to Half
        // Canvas before the upgrade POST could fire.
        var isCartMutate = /\/cart\/(change|update|clear)\.js/.test(url)
          && String(method).toUpperCase() === 'POST';
        var p = origFetch.apply(this, arguments);
        // Skip chaining if reconcile is already running — otherwise we
        // deadlock: reconcile's own internal post('/cart/update.js') would
        // go through this wrapper, try to chain another reconcile(), and
        // the in-flight reconcile promise it gets back is waiting on the
        // very post that's asking for it. Event-driven schedule() already
        // re-runs reconcile if the cart changes further.
        if (!isCartMutate || busy || window.__csAddInFlight) return p;
        // Mark dirty immediately so a synchronous checkout click will wait.
        window.__csCartDirty = true;
        // Chain reconcile after the mutation resolves, and hand the caller a
        // promise that only resolves after reconcile has completed. Clone the
        // response so the original consumer still gets a valid body.
        return p.then(function (res) {
          var clone = res.clone ? res.clone() : res;
          return reconcile().then(
            function () { window.__csCartDirty = false; return clone; },
            function () { window.__csCartDirty = false; return clone; }
          );
        });
      };
    }
  })();

  /* -- Checkout guard. Cheap, synchronous fast path:
        Normally cart mutations already chain the reconcile step via the
        fetch wrapper above (atomic), so by the time any mutation resolves
        the cart is consistent. This guard is just a belt-and-suspenders
        check for the rare case where the cart is still mid-reconcile when
        the user clicks checkout (window.__csCartDirty === true) or the
        cart arrived on the page in an already-inconsistent state.
        No /cart.js fetch on the happy path → zero delay when clean. -- */
  (function installCheckoutGuard() {
    if (window.__csCheckoutGuardInstalled) return;
    window.__csCheckoutGuardInstalled = true;

    function isCheckoutTrigger(el) {
      if (!el || !el.closest) return false;
      // Shopify checkout buttons: name="checkout", or href containing /checkout,
      // or common class/id patterns.
      var btn = el.closest(
        'button[name="checkout"],' +
        'input[name="checkout"],' +
        'a[href$="/checkout"],' +
        'a[href*="/checkout?"],' +
        'a[href*="/checkout/"],' +
        '#checkout,' +
        '.cart__checkout,' +
        '.cart__checkout-button,' +
        '[data-testid="Checkout-button"],' +
        '.shopify-payment-button__button'
      );
      return btn || null;
    }

    function guard(e) {
      var target = e.target;
      var trigger = isCheckoutTrigger(target);
      if (!trigger) return;
      // Don't double-intercept if we already handled this event
      if (trigger.__csGuardHandled) return;

      // Fast path: cart is clean → let the click through with zero delay.
      var dirty = window.__csCartDirty === true
        || window.__csReconcileInFlight
        || window.__csAddInFlight;
      if (!dirty) return;

      // Slow path: a cart mutation is still settling. Block, wait for it.
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation && e.stopImmediatePropagation();

      var prevText = trigger.innerText;
      var prevDisabled = trigger.disabled;
      try {
        trigger.disabled = true;
        if (trigger.innerText) trigger.innerText = 'Updating cart…';
      } catch (err) {}

      // Wait for add-in-flight to clear (poll), then any reconcile to settle.
      function waitAddClear() {
        if (!window.__csAddInFlight) return Promise.resolve();
        return new Promise(function(resolve){
          var deadline = Date.now() + 12000;
          (function tick(){
            if (!window.__csAddInFlight || Date.now() > deadline) return resolve();
            setTimeout(tick, 100);
          })();
        });
      }
      var pending = waitAddClear().then(function(){
        return window.__csReconcileInFlight || Promise.resolve();
      });
      Promise.resolve(pending).then(function(){
        try {
          trigger.disabled = prevDisabled;
          if (prevText) trigger.innerText = prevText;
        } catch (err) {}
        // Re-dispatch the action: for anchor → navigate; for button in
        // a form → submit the form; otherwise re-click with handled flag.
        trigger.__csGuardHandled = true;
        if (trigger.tagName === 'A' && trigger.href) {
          window.location.href = trigger.href;
          return;
        }
        var form = trigger.closest('form');
        if (form) {
          // Replicate button-name submission so Shopify routes to checkout
          if (trigger.name) {
            var hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = trigger.name;
            hidden.value = trigger.value || '';
            form.appendChild(hidden);
          }
          form.submit();
          return;
        }
        trigger.click();
      }).catch(function(){
        try {
          trigger.disabled = prevDisabled;
          if (prevText) trigger.innerText = prevText;
        } catch (err) {}
      });
    }

    // Capture phase so we run before Shopify's own handlers
    document.addEventListener('click', guard, true);
    document.addEventListener('submit', function(e){
      var form = e.target;
      if (!form || !form.action) return;
      if (form.action.indexOf('/cart') === -1 && form.action.indexOf('/checkout') === -1) return;
      // Look for a checkout button inside the form
      var btn = form.querySelector('button[name="checkout"], input[name="checkout"]');
      if (!btn) return;
      if (btn.__csGuardHandled) return;
      e.preventDefault();
      e.stopPropagation();
      btn.__csGuardHandled = true;
      // Reuse the same flow via a synthetic click
      var ev = new MouseEvent('click', {bubbles:true, cancelable:true});
      btn.dispatchEvent(ev);
    }, true);
  })();

  /* -- Inject styles for row-interaction indicator -- */
  (function injectInteractionStyle() {
    if (document.getElementById('cs-cust-interacted-style')) return;
    var st = document.createElement('style');
    st.id = 'cs-cust-interacted-style';
    st.textContent =
      '.cs-cust-row{position:relative;}' +
      '.cs-cust-row--interacted .cs-cust-row-label{padding-left:14px;position:relative;}' +
      '.cs-cust-row--interacted .cs-cust-row-label::before{' +
        'content:"";position:absolute;left:0;top:50%;' +
        'width:8px;height:8px;border-radius:50%;' +
        'background:#2e7d32;transform:translateY(-50%);' +
      '}' +
      '.cs-upcharge{' +
        'display:inline-block;margin-left:4px;padding:1px 6px;' +
        'font-size:11px;font-weight:600;letter-spacing:.02em;' +
        'color:#2e7d32;background:#e8f5e9;border-radius:3px;' +
      '}' +
      '.cs-cart-edit-link{' +
        'display:inline-block;margin-top:6px;font-size:12px;' +
        'color:#1a1a1a;text-decoration:underline;cursor:pointer;' +
      '}' +
      '.cs-cart-edit-link:hover{color:#000;}';
    document.head.appendChild(st);
  })();

  /* -- Option data from Oliver Wicks -- */
  var STEPS = [
    {
      id: 'lapels', name: 'Jacket Lapels', type: 'radio',
      desc: 'Notch lapels are a safe choice for most suits. Peak lapels are a stylish alternative. Shawl lapels are usually reserved for tuxedos.',
      options: [
        { name: 'Notch (3-3.2")', img: OW_CDN+'/radios/1/1.jpg', default: true },
        { name: 'Slim Notch (2.5")', img: OW_CDN+'/radios/1/100.jpg' },
        { name: 'Peak (3-3.2")', img: OW_CDN+'/radios/1/3.jpg' },
        { name: 'Wide Peak (3.75")', img: OW_CDN+'/radios/2/102.jpg' },
        { name: 'Wide Notch (3.75")', img: OW_CDN+'/radios/2/188.jpg' }
      ]
    },
    {
      id: 'vents', name: 'Jacket Vents', type: 'radio',
      desc: 'We recommend two vents for most builds, as they provide better comfort and an optimal drape on the back.',
      options: [
        { name: 'None', img: OW_CDN+'/radios/1/5.jpg' },
        { name: 'One', img: OW_CDN+'/radios/1/6.jpg' },
        { name: 'Two', img: OW_CDN+'/radios/1/7.jpg', default: true }
      ]
    },
    {
      id: 'buttons', name: 'Buttons', type: 'radio',
      desc: 'The two-button style is the best choice for most jackets, as it allows a more tapered waist. One-button suits have more flair.',
      options: [
        { name: 'One', img: OW_CDN+'/radios/1/8.jpg' },
        { name: 'Two', img: OW_CDN+'/radios/1/9.jpg', default: true },
        { name: 'Three', img: OW_CDN+'/radios/1/10.jpg' },
        { name: 'Double-breasted', img: OW_CDN+'/radios/1/13.jpg' },
        { name: 'Three-Roll-Two', img: OW_CDN+'/radios/2/131.jpg' }
      ]
    },
    {
      id: 'pockets', name: 'Pockets', type: 'radio',
      desc: 'Ticket pockets and slanted pockets add variety to your wardrobe. If in doubt, go with the usual straight pocket design.',
      options: [
        { name: 'Straight', img: OW_CDN+'/radios/2/157.gif', default: true },
        { name: 'Slanted', img: OW_CDN+'/radios/2/158.gif' },
        { name: 'Straight + Ticket', img: OW_CDN+'/radios/2/159.gif' },
        { name: 'Slanted + Ticket', img: OW_CDN+'/radios/2/160.gif' },
        { name: 'Patch Pockets', img: OW_CDN+'/radios/2/161.gif' }
      ]
    },
    {
      id: 'canvas', name: 'Canvas Construction', type: 'radio',
      desc: 'Half-canvas provides shape and support where it matters most. Full canvas extends down to the end of the front piece.',
      options: [
        { name: 'Half Canvas', img: OW_CDN+'/radios/3/248.png', default: true },
        { name: 'Full Canvas', img: OW_CDN+'/radios/3/249.png' }
      ]
    },
    {
      id: 'monogram', name: 'Jacket Monogram', type: 'radio',
      desc: 'Add your initials or full name on the left side of the jacket lining.',
      options: [
        { name: 'No Monogram', img: OW_CDN+'/radios/2/143.jpg', default: true },
        { name: 'Initials', img: OW_CDN+'/radios/2/144.jpg', hasInput: true, inputLabel: 'Your initials' },
        { name: 'Full Name', img: OW_CDN+'/radios/2/145.jpg', hasInput: true, inputLabel: 'Your name' }
      ]
    },
    {
      id: 'lining', name: 'Jacket Lining', type: 'radio',
      desc: 'Choose a color for the lining of your jacket.',
      options: [
        { name: 'Solid Red', img: OW_CDN+'/radios/2/179.jpg' },
        { name: 'Solid Intense Red', img: OW_CDN+'/radios/3/206.jpg' },
        { name: 'Solid Burgundy', img: OW_CDN+'/radios/2/200.png' },
        { name: 'Solid Chocolate', img: OW_CDN+'/radios/3/201.jpg' },
        { name: 'Solid Bronze', img: OW_CDN+'/radios/3/204.jpg', default: true },
        { name: 'Solid Light Blue', img: OW_CDN+'/radios/3/241.png' },
        { name: 'Solid True Blue', img: OW_CDN+'/radios/3/242.jpg' },
        { name: 'Solid Deep Blue', img: OW_CDN+'/radios/3/243.jpg' },
        { name: 'Solid Dark Navy', img: OW_CDN+'/radios/3/210.jpg' },
        { name: 'Solid Black', img: OW_CDN+'/radios/2/182.png' },
        { name: 'Solid Brown', img: OW_CDN+'/radios/2/183.png' },
        { name: 'Solid Green', img: OW_CDN+'/radios/3/213.png' },
        { name: 'Solid Grey', img: OW_CDN+'/radios/2/174.png' },
        { name: 'Solid Copper', img: OW_CDN+'/radios/3/233.jpg' },
        { name: 'Solid Pink', img: OW_CDN+'/radios/3/234.png' },
        { name: 'Dark Red Bemberg', img: OW_CDN+'/radios/2/197.jpg' },
        { name: 'Red Floral Bemberg', img: OW_CDN+'/radios/3/216.jpg' },
        { name: 'Dotted Light Blue Bemberg', img: OW_CDN+'/radios/3/220.jpg' },
        { name: 'Sky Blue & Gold Striped', img: OW_CDN+'/radios/3/225.jpg' },
        { name: 'Blue & Light Blue Striped', img: OW_CDN+'/radios/3/227.jpg' },
        { name: 'Red & Burgundy Striped', img: OW_CDN+'/radios/3/229.jpg' }
      ]
    }
  ];
  var MORE_OPTIONS = [
    {
      id: 'jacket_details', name: 'Jacket & Vest Details', type: 'checkbox',
      options: [
        { name: 'Pick Stitching', img: OW_CDN+'/checkboxes/1/7.jpg', default: true, desc: 'A barely visible stitch running along the edges of lapels, collar, jacket front and pockets.' },
        { name: 'Boutonniere', img: OW_CDN+'/checkboxes/1/10.jpg', default: true, desc: 'Allows you to put your favourite pin or flower on your lapel for special occasions.' },
        { name: 'Contrast Boutonniere', img: OW_CDN+'/checkboxes/1/80.jpg', desc: 'Boutonniere in the color of your lining.' },
        { name: 'Contrast Sleeve Buttonhole', img: OW_CDN+'/checkboxes/1/32.gif', desc: 'Last sleeve buttonhole in the color of your lining for a bolder, casual look.' },
        { name: 'Half-lined Jacket', img: OW_CDN+'/checkboxes/1/17.jpg', desc: 'No lining on the back for better ventilation. Excellent for summer.' },
        { name: 'Unpadded Shoulders', img: OW_CDN+'/checkboxes/1/42.png', default: true, desc: 'Shoulders with no padding for an even softer feel.' }
      ]
    },
    {
      id: 'pants_details', name: 'Pants Details', type: 'checkbox',
      options: [
        { name: 'Two Back Pockets', img: OW_CDN+'/checkboxes/1/8.jpg', default: true, desc: 'Default has 1 back pocket on the right. Check for two back pockets.' },
        { name: 'Pant Cuffs', img: OW_CDN+'/checkboxes/1/12.jpg', desc: 'Cuffed pants with a 1.5" default cuff size.' },
        { name: 'Suspender Buttons', img: OW_CDN+'/checkboxes/1/16.jpg', desc: 'Y-configuration suspender buttons. Belt loops still included.' },
        { name: 'Pleats', img: OW_CDN+'/checkboxes/1/33.jpg', desc: 'Classic single-pleated front.' },
        { name: 'Side Tabs', img: OW_CDN+'/checkboxes/1/40.png', desc: 'Side tabs instead of belt loops.' }
      ]
    },
    {
      id: 'general', name: 'General', type: 'checkbox',
      options: [
        { name: 'Dark Brown Melange Buttons', img: OW_CDN+'/checkboxes/1/46.jpg', desc: 'Swap the default black buttons with dark brown melange.' }
      ]
    }
  ];

  /* -- State -- */
  var selections = {};
  var checkSelections = {};
  // Expose to window so the fetch hook (installed at load time) can read
  // the current canvas selection at the moment of Add to Cart.
  window.__csSelections = selections;

  function initSelections() {
    STEPS.forEach(function(step) {
      step.options.forEach(function(opt) {
        if (opt.default) selections[step.id] = opt.name;
      });
      if (!selections[step.id] && step.options.length) selections[step.id] = step.options[0].name;
    });
    MORE_OPTIONS.forEach(function(group) {
      checkSelections[group.id] = {};
      group.options.forEach(function(opt) {
        checkSelections[group.id][opt.name] = !!opt.default;
      });
    });

    /* -- Edit-mode prefill: if URL contains ?edit=...&p_<step>=name params,
          override the defaults so the customer sees their prior selections.
          Param names use the step id and group id (lowercase). -- */
    try {
      var params = new URLSearchParams(window.location.search);
      var editBundle = params.get('edit');
      var monogramText = '';
      if (editBundle) {
        window.__csReplaceBundle = editBundle;
      }
      STEPS.forEach(function(step) {
        var v = params.get('p_' + step.id);
        if (v) {
          // Monogram comes through as "Initials: ABC" — split off the text part
          if (step.id === 'monogram' && v.indexOf(': ') !== -1) {
            var parts = v.split(': ');
            selections.monogram = parts[0];
            monogramText = parts.slice(1).join(': ');
          } else {
            // Match against known option names
            var match = step.options.find(function(o){ return o.name === v; });
            if (match) selections[step.id] = v;
          }
        }
      });
      MORE_OPTIONS.forEach(function(group) {
        var v = params.get('c_' + group.id);
        if (v !== null) {
          // Reset all checkboxes in this group, then enable matching ones
          Object.keys(checkSelections[group.id]).forEach(function(k){
            checkSelections[group.id][k] = false;
          });
          if (v) {
            v.split('|').forEach(function(name){
              if (name in checkSelections[group.id]) checkSelections[group.id][name] = true;
            });
          }
        }
      });
      if (monogramText) {
        // Stash for later application once the input exists
        window.__csPrefillMonogramText = monogramText;
      }
    } catch (e) {}
  }

  /* -- DOM helpers -- */
  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html) e.innerHTML = html;
    return e;
  }

  /* -- Build main customize panel -- */
  function buildPanel() {
    var wrap = document.getElementById('cs-customize-wrap');
    if (wrap) wrap.remove();

    var buyForm = document.querySelector('form[action*="/cart/add"], product-form form, .product-form form');
    if (!buyForm) return;

    wrap = el('div', 'cs-customize-wrap');
    wrap.id = 'cs-customize-wrap';

    // Title (clickable to expand/collapse)
    var header = el('div', 'cs-cust-header');
    header.innerHTML = '<span class="cs-cust-title">Customize Your Suit</span>' +
      '<svg class="cs-cust-chevron" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5"/></svg>';
    header.style.cursor = 'pointer';
    header.addEventListener('click', function() {
      var listView = document.getElementById('cs-cust-list');
      var chevron = header.querySelector('.cs-cust-chevron');
      var isOpen = listView.style.display !== 'none';
      listView.style.display = isOpen ? 'none' : 'block';
      if (chevron) chevron.style.transform = isOpen ? 'rotate(0deg)' : 'rotate(180deg)';
    });
    wrap.appendChild(header);

    // Option rows (list view) -- collapsed by default
    var listView = el('div', 'cs-cust-list');
    listView.id = 'cs-cust-list';
    listView.style.display = 'none';

    STEPS.forEach(function(step) {
      var row = el('div', 'cs-cust-row');
      row.setAttribute('data-step', step.id);
      var initVal = selections[step.id] || '';
      var initSuffix = (step.id === 'canvas' && initVal === 'Full Canvas')
        ? ' <span class="cs-upcharge">' + FULL_CANVAS_UPCHARGE_LABEL + '</span>' : '';
      row.innerHTML = '<span class="cs-cust-row-label">' + step.name + '</span>' +
        '<span class="cs-cust-row-value">' + initVal + initSuffix +
        ' <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 1L6.5 6L1.5 11" stroke="currentColor" stroke-width="1.5"/></svg></span>';
      row.addEventListener('click', function() {
        row.classList.add('cs-cust-row--interacted');
        showStepDetail(step);
      });
      listView.appendChild(row);
    });

    // More Options toggle
    var moreToggle = el('button', 'cs-cust-more-toggle');
    moreToggle.id = 'cs-more-toggle';
    moreToggle.innerHTML = 'More Options <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5"/></svg>';
    moreToggle.addEventListener('click', function() {
      var moreWrap = document.getElementById('cs-more-options');
      var isOpen = moreWrap.style.display !== 'none';
      moreWrap.style.display = isOpen ? 'none' : 'block';
      this.innerHTML = (isOpen ? 'More Options' : 'Hide Options') +
        ' <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform:rotate(' + (isOpen ? '0' : '180') + 'deg)"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5"/></svg>';
    });
    listView.appendChild(moreToggle);

    // More Options sections
    var moreWrap = el('div', 'cs-more-options');
    moreWrap.id = 'cs-more-options';
    moreWrap.style.display = 'none';

    MORE_OPTIONS.forEach(function(group) {
      var section = el('div', 'cs-more-section');
      section.innerHTML = '<div class="cs-more-section-title">' + group.name + '</div>';
      group.options.forEach(function(opt) {
        var chkRow = el('div', 'cs-cust-row cs-cust-row-check');
        chkRow.setAttribute('data-group', group.id);
        chkRow.setAttribute('data-opt', opt.name);
        var checked = checkSelections[group.id] && checkSelections[group.id][opt.name];
        chkRow.innerHTML = '<span class="cs-cust-row-label">' + opt.name + '</span>' +
          '<span class="cs-cust-row-value"><span class="cs-check-indicator ' + (checked ? 'cs-checked' : '') + '">' +
          (checked ? '&#10003;' : '') + '</span></span>';
        chkRow.addEventListener('click', function() {
          chkRow.classList.add('cs-cust-row--interacted');
          showCheckDetail(group, opt);
        });
        section.appendChild(chkRow);
      });
      moreWrap.appendChild(section);
    });
    listView.appendChild(moreWrap);
    wrap.appendChild(listView);

    // Detail view (hidden initially)
    var detailView = el('div', 'cs-cust-detail');
    detailView.id = 'cs-cust-detail';
    detailView.style.display = 'none';
    wrap.appendChild(detailView);

    // Insert before buy button
    buyForm.parentNode.insertBefore(wrap, buyForm);
  }

  /* -- Show step detail (expanded option cards) -- */
  function showStepDetail(step) {
    var list = document.getElementById('cs-cust-list');
    var detail = document.getElementById('cs-cust-detail');
    list.style.display = 'none';
    detail.style.display = 'block';

    var closePanelJs = "document.getElementById('cs-cust-list').style.display='block';document.getElementById('cs-cust-detail').style.display='none';";
    var html = '<div class="cs-detail-header" style="display:flex;align-items:center;justify-content:space-between;gap:8px;">' +
      '<button class="cs-detail-back" onclick="' + closePanelJs + '">' +
      '<svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 1L1.5 6L6.5 11" stroke="currentColor" stroke-width="1.5"/></svg></button>' +
      '<span class="cs-detail-title" style="flex:1;text-align:center;">' + step.name.toUpperCase() + '</span>' +
      '<button class="cs-detail-done" onclick="' + closePanelJs + '" ' +
        'style="background:#000;color:#fff;border:0;border-radius:4px;padding:8px 16px;' +
        'font-size:13px;font-weight:600;letter-spacing:0.5px;text-transform:uppercase;cursor:pointer;">' +
        'Done</button>' +
      '</div>';

    html += '<div class="cs-detail-grid">';
    step.options.forEach(function(opt) {
      var selected = selections[step.id] === opt.name;
      html += '<div class="cs-detail-card' + (selected ? ' cs-detail-card--selected' : '') + '" data-step="' + step.id + '" data-name="' + opt.name.replace(/"/g, '&quot;') + '">' +
        (selected ? '<div class="cs-detail-check"><svg width="16" height="16" viewBox="0 0 16 16"><circle cx="8" cy="8" r="8" fill="#000"/><path d="M4.5 8L7 10.5L11.5 5.5" stroke="#fff" stroke-width="1.5" fill="none"/></svg></div>' : '') +
        '<div class="cs-detail-img"><img src="' + opt.img + '" alt="' + opt.name.replace(/"/g, '&quot;') + '" /></div>' +
        '<div class="cs-detail-label">' + opt.name +
          (step.id === 'canvas' && opt.name === 'Full Canvas' ? ' <span class="cs-upcharge">' + FULL_CANVAS_UPCHARGE_LABEL + '</span>' : '') +
        '</div></div>';
    });
    html += '</div>';

    // Description
    var currentOpt = step.options.find(function(o) { return o.name === selections[step.id]; });
    html += '<div class="cs-detail-desc">' +
      '<div class="cs-detail-desc-name">' + (selections[step.id] || '') + '</div>' +
      '<div class="cs-detail-desc-text">' + step.desc + '</div></div>';

    // Monogram input if applicable
    if (step.id === 'monogram' && currentOpt && currentOpt.hasInput) {
      html += '<div class="cs-monogram-input"><input type="text" id="cs-monogram-text" placeholder="' + (currentOpt.inputLabel || 'Enter text') + '" maxlength="30" /></div>';
    }

    detail.innerHTML = html;

    // Bind card clicks
    detail.querySelectorAll('.cs-detail-card').forEach(function(card) {
      card.addEventListener('click', function() {
        var stepId = this.getAttribute('data-step');
        var name = this.getAttribute('data-name');
        selections[stepId] = name;
        showStepDetail(step); // Re-render detail
        updateRowValue(stepId, name);
        _writeSelectionsToForm();
      });
    });
    // Keep monogram text input in sync as user types
    var mono = document.getElementById('cs-monogram-text');
    if (mono) {
      // Apply prefilled monogram text from edit URL if present
      if (window.__csPrefillMonogramText) {
        mono.value = window.__csPrefillMonogramText;
        window.__csPrefillMonogramText = null;
        _writeSelectionsToForm();
      }
      mono.addEventListener('input', function() { _writeSelectionsToForm(); });
    }
  }

  /* -- Show checkbox detail -- */
  function showCheckDetail(group, opt) {
    // Toggle checkbox
    checkSelections[group.id][opt.name] = !checkSelections[group.id][opt.name];
    var checked = checkSelections[group.id][opt.name];

    // Update the row indicator
    var rows = document.querySelectorAll('.cs-cust-row-check[data-group="' + group.id + '"][data-opt="' + opt.name + '"]');
    rows.forEach(function(row) {
      var ind = row.querySelector('.cs-check-indicator');
      if (ind) {
        ind.className = 'cs-check-indicator ' + (checked ? 'cs-checked' : '');
        ind.innerHTML = checked ? '&#10003;' : '';
      }
    });
    _writeSelectionsToForm();
  }

  /* -- Update row value text after selection -- */
  function updateRowValue(stepId, name) {
    var row = document.querySelector('.cs-cust-row[data-step="' + stepId + '"]');
    if (row) {
      var valSpan = row.querySelector('.cs-cust-row-value');
      if (valSpan) {
        var suffix = (stepId === 'canvas' && name === 'Full Canvas')
          ? ' <span class="cs-upcharge">' + FULL_CANVAS_UPCHARGE_LABEL + '</span>' : '';
        valSpan.innerHTML = name + suffix + ' <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 1L6.5 6L1.5 11" stroke="currentColor" stroke-width="1.5"/></svg>';
      }
    }
  }

  /* -- Write customizations into form as hidden inputs, kept in sync.
        Horizon's add-to-cart-component reads the form's FormData via its
        own click handler (not a native submit event), so we cannot rely
        on a submit listener — we have to pre-populate the inputs. -- */
  function writeSelectionsToForm() {
    var form = document.querySelector('form[action*="/cart/add"], product-form form');
    if (!form) return;
    function upsert(propName, value) {
      var sel = 'input[name="properties[' + propName + ']"]';
      var input = form.querySelector(sel);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + propName + ']';
        input.setAttribute('data-cs-prop', '1');
        form.appendChild(input);
      }
      input.value = value;
    }
    // Radio selections
    Object.keys(selections).forEach(function(key) {
      var step = STEPS.find(function(s) { return s.id === key; });
      if (!step) return;
      var val = selections[key];
      if (key === 'monogram' && val !== 'No Monogram') {
        var textInput = document.getElementById('cs-monogram-text');
        if (textInput && textInput.value) val += ': ' + textInput.value;
      }
      upsert(step.name, val);
    });
    // Checkbox groups
    MORE_OPTIONS.forEach(function(group) {
      var selected = [];
      Object.keys(checkSelections[group.id] || {}).forEach(function(optName) {
        if (checkSelections[group.id][optName]) selected.push(optName);
      });
      // Remove any stale input if nothing selected, so we don't ship an empty property
      var existing = form.querySelector('input[name="properties[' + group.name + ']"]');
      if (selected.length) {
        upsert(group.name, selected.join(', '));
      } else if (existing) {
        existing.parentNode.removeChild(existing);
      }
    });
  }
  // Expose for other handlers in this IIFE
  var _writeSelectionsToForm = writeSelectionsToForm;

  /* -- Init -- */
  function initCustomize() {
    // Only run on product pages
    if (window.location.pathname.indexOf('/products/') === -1) return;

    var buyForm = document.querySelector('form[action*="/cart/add"], product-form form, .product-form form');
    if (!buyForm) {
      setTimeout(initCustomize, 300);
      return;
    }

    initSelections();
    buildPanel();
    writeSelectionsToForm(); // seed default customizations into the form
    collapseDescription();
    prefillVariantOptionsFromUrl();
  }

  /* -- When the customer arrives via an Edit link, the URL has ?sizes=J|W|I
        with jacket size, waist, inseam in that order. The theme's custom
        size-box UI uses <button class="cs-size-btn"> tiles inside
        #cs-jacket-box and #cs-pants-box (not native selects), so we click
        the matching tile — the theme's click handler updates the label,
        applies cs-box--selected, and syncs the hidden variant-picker
        select. Retries because the boxes render asynchronously. -- */
  function prefillVariantOptionsFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      var sizesParam = params.get('sizes');
      var variantId = parseInt(params.get('variant'), 10);
      if (!sizesParam) return;
      var vals = sizesParam.split('|'); // [jacket, waist, inseam]
      var jacketVal = vals[0], waistVal = vals[1], inseamVal = vals[2];

      function clickTile(gridEl, targetText) {
        if (!gridEl) return false;
        var btns = gridEl.querySelectorAll('.cs-size-btn');
        for (var i = 0; i < btns.length; i++) {
          if (btns[i].textContent.trim() === String(targetText).trim()) {
            btns[i].click();
            return true;
          }
        }
        return false;
      }

      function applyAll() {
        var jacketBox = document.getElementById('cs-jacket-box');
        var pantsBox = document.getElementById('cs-pants-box');
        if (!jacketBox || !pantsBox) return false;

        var allDone = true;

        // Jacket: single grid
        if (jacketVal && !jacketBox.classList.contains('cs-box--selected')) {
          var jg = jacketBox.querySelector('.cs-size-grid');
          if (!clickTile(jg, jacketVal)) allDone = false;
        }

        // Pants: two grids, first = waist, second = inseam
        if (waistVal || inseamVal) {
          var grids = pantsBox.querySelectorAll('.cs-size-grid');
          if (grids.length < 2) {
            allDone = false;
          } else {
            if (waistVal)  clickTile(grids[0], waistVal);
            if (inseamVal) clickTile(grids[1], inseamVal);
          }
        }

        // Force the hidden id input to the exact variant
        if (variantId) {
          var idInput = document.querySelector('input[name="id"]');
          if (idInput) idInput.value = String(variantId);
        }
        return allDone;
      }

      applyAll();
      [100, 300, 600, 1200, 2000, 3000].forEach(function(delay){
        setTimeout(applyAll, delay);
      });
    } catch (e) {}
  }

  /* -- Collapse Description accordion by default -- */
  function collapseDescription() {
    function findAndClose() {
      var accordions = document.querySelectorAll('.cs-accordion');
      var found = false;
      accordions.forEach(function(acc) {
        var btn = acc.querySelector('button.cs-accordion-header');
        if (btn && btn.textContent.trim().toUpperCase().indexOf('DESCRIPTION') > -1) {
          if (acc.classList.contains('cs-accordion--open')) {
            btn.click();
            found = true;
          }
        }
      });
      return found;
    }

    if (!findAndClose()) {
      var attempts = 0;
      var poll = setInterval(function() {
        if (findAndClose() || ++attempts > 20) clearInterval(poll);
      }, 250);
    }
  }

  // Run collapseDescription ASAP -- script has defer so DOM is parsed
  collapseDescription();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(initCustomize, 500); });
  } else {
    setTimeout(initCustomize, 500);
  }
})();

/* === Product Image Thumbnails === */
function initProductThumbnails() {
  var gallery = document.querySelector('media-gallery');
  var sc = document.querySelector('slideshow-component');
  if (!gallery || !sc || !sc.slides || sc.slides.length < 2) return;
  if (document.getElementById('cs-thumb-strip')) return;

  var slides = sc.slides;
  var strip = document.createElement('div');
  strip.id = 'cs-thumb-strip';

  for (var i = 0; i < slides.length; i++) {
    var img = slides[i].querySelector('img');
    if (!img) continue;
    var thumb = document.createElement('div');
    thumb.className = 'cs-thumb' + (i === 0 ? ' cs-thumb--active' : '');
    thumb.dataset.index = i;
    var thumbImg = document.createElement('img');
    thumbImg.src = img.src;
    thumbImg.alt = img.alt || 'Product image ' + (i + 1);
    thumbImg.loading = 'lazy';
    thumb.appendChild(thumbImg);
    thumb.addEventListener('click', function() {
      var idx = parseInt(this.dataset.index);
      sc.select(idx);
      updateActiveThumbnail(idx);
    });
    strip.appendChild(thumb);
  }

  gallery.insertBefore(strip, gallery.firstChild);

  var observer = new MutationObserver(function() {
    if (typeof sc.current !== 'undefined') {
      updateActiveThumbnail(sc.current);
    }
  });
  observer.observe(sc, { attributes: true, subtree: true });

  function updateActiveThumbnail(idx) {
    var thumbs = strip.querySelectorAll('.cs-thumb');
    for (var j = 0; j < thumbs.length; j++) {
      if (j === idx) {
        thumbs[j].classList.add('cs-thumb--active');
      } else {
        thumbs[j].classList.remove('cs-thumb--active');
      }
    }
  }
}

/* === Show Fabric Mill below product title === */
function showFabricMill() {
  if (document.getElementById('cs-fabric-mill')) return;
  var title = document.querySelector('.product-information h1');
  if (!title) return;
  var path = window.location.pathname;
  var handleMatch = path.match(/\/products\/([^/?#]+)/);
  if (!handleMatch) return;
  fetch('/products/' + handleMatch[1] + '.json')
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (!data.product || !data.product.tags) return;
      var tags = data.product.tags.split(', ');
      var millName = '';
      for (var i = 0; i < tags.length; i++) {
        if (tags[i].indexOf('mill:') === 0) {
          millName = tags[i].substring(5);
          break;
        }
      }
      if (!millName) return;
      if (document.getElementById('cs-fabric-mill')) return;
      var mill = document.createElement('div');
      mill.id = 'cs-fabric-mill';
      mill.textContent = millName;
      title.insertAdjacentElement('afterend', mill);
    })
    .catch(function() {});
}

/* === Larger product image === */
function initLargerImage() {
  var sc = document.querySelector('slideshow-component');
  if (!sc) return;
  sc.style.aspectRatio = '3 / 4';
  var container = sc.querySelector('slideshow-container');
  var slides = sc.querySelector('slideshow-slides');
  if (container) container.style.height = '100%';
  if (slides) slides.style.height = '100%';
  var allSlides = sc.querySelectorAll('slideshow-slide');
  allSlides.forEach(function(s) {
    s.style.height = '100%';
    var img = s.querySelector('img');
    if (img) {
      img.style.objectFit = 'contain';
      img.style.height = '100%';
      img.style.width = '100%';
    }
  });
}

/* === Run all enhancements === */
// Retry thumbnails until slideshow-component is fully ready — it upgrades
// asynchronously as a custom element, and a fixed 500ms delay isn't reliable.
// Then attach a MutationObserver on media-gallery so the strip survives any
// re-render (variant change, media swap, etc) that wipes it.
function initProductThumbnailsWhenReady() {
  var tries = 0;
  function tryInitOnce() {
    var sc = document.querySelector('slideshow-component');
    var gallery = document.querySelector('media-gallery');
    if (sc && gallery && sc.slides && sc.slides.length >= 2 &&
        !document.getElementById('cs-thumb-strip')) {
      initProductThumbnails();
    }
    return !!document.getElementById('cs-thumb-strip');
  }
  // Retry init until slideshow-component finishes upgrading (custom element
  // may register after DOMContentLoaded).
  function attempt() {
    if (tryInitOnce()) {
      attachStableObserver();
      return;
    }
    if (++tries < 40) setTimeout(attempt, 200);
  }
  // Observe a STABLE ancestor, not media-gallery itself. Horizon replaces
  // the whole <media-gallery> element on variant change (size button click),
  // which orphans any observer attached directly to the gallery. Walking up
  // to the product form / body means the observer survives that swap and can
  // detect the new gallery + missing thumb strip and re-run init.
  function attachStableObserver() {
    if (window.__csThumbStableObs) return;
    // media-gallery is a SIBLING of product-form-component, not a descendant.
    // Prefer its immediate parent (.product-information__media) which persists
    // across variant swaps; fall back to the shopify-section wrapper, then main.
    var gallery = document.querySelector('media-gallery');
    var root = (gallery && gallery.parentElement) ||
               document.querySelector('.product-information__media') ||
               document.querySelector('[id^="shopify-section-template"]') ||
               document.querySelector('main') ||
               document.body;
    if (!root) return;
    window.__csThumbStableObs = true;
    var restoring = false;
    var mo = new MutationObserver(function(){
      if (restoring) return;
      if (document.getElementById('cs-thumb-strip')) return;
      // Only act if a gallery exists to build a strip from
      var sc = document.querySelector('slideshow-component');
      if (!sc) return;
      restoring = true;
      // Let Horizon finish its re-render before we rebuild the strip
      setTimeout(function(){
        var sc2 = document.querySelector('slideshow-component');
        // Poll briefly because the newly-inserted slideshow may not have
        // upgraded / populated .slides yet at the moment of the mutation.
        var innerTries = 0;
        (function pollSlides(){
          if (document.getElementById('cs-thumb-strip')) {
            restoring = false;
            return;
          }
          var s = document.querySelector('slideshow-component');
          if (s && s.slides && s.slides.length >= 2) {
            initProductThumbnails();
            restoring = false;
            return;
          }
          if (++innerTries < 20) {
            setTimeout(pollSlides, 100);
          } else {
            restoring = false;
          }
        })();
      }, 50);
    });
    mo.observe(root, {childList: true, subtree: true});
  }
  attempt();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(showFabricMill, 300);
    setTimeout(initLargerImage, 400);
    initProductThumbnailsWhenReady();
  });
} else {
  setTimeout(showFabricMill, 300);
  setTimeout(initLargerImage, 400);
  initProductThumbnailsWhenReady();
}


/* === Hide ATC while customization detail view is open ===
   Only targets the buy buttons — NOT product-form-component, because
   .cs-customize-wrap is a descendant of it and would collapse too. */
(function initHideAtcInDetailView() {
  function install() {
    var detail = document.querySelector('.cs-cust-detail');
    if (!detail) return false;

    var styleTag = document.getElementById('cs-hide-atc-style');
    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = 'cs-hide-atc-style';
      document.head.appendChild(styleTag);
    }
    styleTag.textContent =
      'body.cs-detail-open add-to-cart-component,' +
      'body.cs-detail-open .shopify-payment-button,' +
      'body.cs-detail-open .shopify-payment-button__button,' +
      'body.cs-detail-open .product-form__buy-buttons' +
      '{display:none !important;}';

    function sync() {
      var open = detail.style.display !== 'none' &&
                 getComputedStyle(detail).display !== 'none';
      document.body.classList.toggle('cs-detail-open', !!open);
    }

    try {
      var mo = new MutationObserver(sync);
      mo.observe(detail, { attributes: true, attributeFilter: ['style', 'class'] });
    } catch (e) {}
    sync();
    return true;
  }

  if (!install()) {
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (install() || tries > 40) clearInterval(iv);
    }, 150);
  }
})();


/* === Require explicit size selection before Add to Cart ===
   Shopify auto-selects the first variant, so customers can ATC without
   ever consciously picking Jacket Size / Pant Waist / Pant Inseam.
   This enforces that all three selects must be touched before ATC
   becomes enabled, and shows a "Select …" placeholder on each. */
(function initRequireSizeSelection() {
  if (window.location.pathname.indexOf('/products/') === -1) return;

  var touched = Object.create(null); // keyed by select.name
  var picker = null;
  var observer = null;
  var atcObserver = null;

  function getSelects() {
    return picker ? [].slice.call(picker.querySelectorAll('select.variant-option__select')) : [];
  }

  function installPlaceholder(sel) {
    if (sel.querySelector('option[data-cs-ph]')) return;
    var ph = document.createElement('option');
    ph.value = '';
    var labelEl = sel.closest('.variant-option') &&
                  sel.closest('.variant-option').querySelector('label');
    var labelText = labelEl ? labelEl.textContent.trim() : 'option';
    ph.textContent = 'Select ' + labelText + '\u2026';
    ph.setAttribute('data-cs-ph', '1');
    ph.disabled = true;
    sel.insertBefore(ph, sel.firstChild);
    sel.value = '';
  }

  function findAtc() {
    return document.querySelector(
      'add-to-cart-component button, button[name="add"], .product-form__submit'
    );
  }

  function update() {
    var selects = getSelects();
    if (selects.length === 0) return;
    selects.forEach(function (sel) {
      if (!touched[sel.name]) installPlaceholder(sel);
      if (!sel.dataset.csHooked) {
        sel.dataset.csHooked = '1';
        sel.addEventListener('change', function () {
          if (sel.value !== '') touched[sel.name] = true;
          update();
        });
      }
    });
    var ok = selects.every(function (s) {
      return touched[s.name] && s.value !== '';
    });
    var atc = findAtc();
    if (atc) {
      atc.disabled = !ok;
      atc.setAttribute('aria-disabled', String(!ok));
      atc.style.opacity = ok ? '' : '0.45';
      atc.style.cursor = ok ? '' : 'not-allowed';
      if (!ok) {
        if (!atc.dataset.csOrig) atc.dataset.csOrig = atc.textContent.trim();
        if (atc.textContent.trim() !== 'Select your sizes') {
          atc.textContent = 'Select your sizes';
        }
      } else if (atc.dataset.csOrig) {
        if (atc.textContent.trim() !== atc.dataset.csOrig) {
          atc.textContent = atc.dataset.csOrig;
        }
      }
    }
  }

  function attachToPicker() {
    picker = document.querySelector('variant-picker, variant-picker-component');
    if (!picker) return false;
    if (observer) observer.disconnect();
    observer = new MutationObserver(function () {
      // On re-render, re-evaluate (re-install placeholders on untouched selects,
      // re-hook change listeners on new select elements, re-apply ATC state).
      update();
    });
    observer.observe(picker, { childList: true, subtree: true });

    // Belt-and-suspenders: also re-apply ATC state on any add-to-cart re-render.
    var atcComp = document.querySelector('add-to-cart-component');
    if (atcComp) {
      if (atcObserver) atcObserver.disconnect();
      atcObserver = new MutationObserver(function () { update(); });
      atcObserver.observe(atcComp, { childList: true, subtree: true });
    }

    // Final safety net: block the form submit if any select is untouched.
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form && !form.dataset.csSizeGated) {
      form.dataset.csSizeGated = '1';
      form.addEventListener('submit', function (e) {
        var selects = getSelects();
        var ok = selects.length > 0 && selects.every(function (s) {
          return touched[s.name] && s.value !== '';
        });
        if (!ok) {
          e.preventDefault();
          e.stopImmediatePropagation();
          alert('Please select your jacket size, pant waist, and pant inseam before adding to cart.');
        }
      }, true);
    }

    update();
    return true;
  }

  function init() {
    if (!attachToPicker()) {
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (attachToPicker() || tries > 40) clearInterval(iv);
      }, 200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* === Hide Full Canvas Upgrade everywhere except cart ===
   The product must remain published on Online Store for /cart/add.js to work
   when the user picks Full Canvas in the customization flow. But it should
   never appear in collection grids, search results, recommendations, or be
   reachable as a standalone product page. We do this entirely on the front
   end so it's reversible and doesn't touch Shopify data. */
(function () {
  var HIDDEN_HANDLES = ['full-canvas-upgrade'];

  // 1. If the customer lands directly on the hidden product page, redirect home.
  function redirectIfOnHiddenProduct() {
    var m = window.location.pathname.match(/^\/products\/([^\/?#]+)/);
    if (m && HIDDEN_HANDLES.indexOf(m[1]) !== -1) {
      window.location.replace('/');
    }
  }
  redirectIfOnHiddenProduct();

  // 2. CSS: hide any product card / link that points at a hidden handle.
  //    Covers Horizon's product cards, search results, recommendations,
  //    and any block that links via /products/<handle>.
  //
  //    IMPORTANT: hide the OUTER grid wrapper (li.product-grid__item),
  //    not just the inner <product-card>. Otherwise the li still occupies a
  //    grid slot and the layout shows an empty cell where the card was.
  function injectHideStyles() {
    if (document.getElementById('cs-hide-products-style')) return;
    var selectors = [];
    HIDDEN_HANDLES.forEach(function (h) {
      // Outer grid wrappers FIRST so they collapse cleanly
      selectors.push('li.product-grid__item:has(a[href*="/products/' + h + '"])');
      selectors.push('.product-grid__item:has(a[href*="/products/' + h + '"])');
      selectors.push('.resource-list__item:has(a[href*="/products/' + h + '"])');
      selectors.push('.collection__item:has(a[href*="/products/' + h + '"])');
      selectors.push('.grid__item:has(a[href*="/products/' + h + '"])');
      selectors.push('.card-wrapper:has(a[href*="/products/' + h + '"])');
      // Predictive-search & menu-drawer cards
      selectors.push('.resource-card:has(a[href*="/products/' + h + '"])');
      selectors.push('li:has(> .resource-card a[href*="/products/' + h + '"])');
      // Recommendation rails
      selectors.push('.product-card:has(a[href*="/products/' + h + '"])');
      selectors.push('product-card:has(a[href*="/products/' + h + '"])');
      // NOTE: intentionally NOT using a bare `a[href*="/products/...]` rule.
      // That would also hide the product title link inside the cart drawer
      // (which is exactly where we DO want the upcharge line to show).
    });
    var style = document.createElement('style');
    style.id = 'cs-hide-products-style';
    style.textContent = selectors.join(',\n') + ' { display: none !important; }';
    document.head.appendChild(style);
  }
  injectHideStyles();

  // 3. Fallback for browsers without :has() and for cases where the link is
  //    nested deeper than the selectors above catch. Walk every product link
  //    and hide its OUTERMOST card/grid-item ancestor (collection grid items
  //    take priority so the grid slot collapses).
  function nukeProductLinks() {
    HIDDEN_HANDLES.forEach(function (h) {
      var links = document.querySelectorAll('a[href*="/products/' + h + '"]');
      links.forEach(function (a) {
        // Don't touch links inside the cart drawer / cart page — we want the
        // upgrade line item to remain visible & removable there.
        if (a.closest('cart-drawer-component, cart-items-component, #CartDrawer, #cart, .cart, [class*="cart"]')) return;
        // Try grid-item / card wrappers in order of OUTERMOST first.
        var card =
          a.closest('li.product-grid__item') ||
          a.closest('.product-grid__item') ||
          a.closest('.resource-list__item') ||
          a.closest('.grid__item') ||
          a.closest('.collection__item') ||
          a.closest('.card-wrapper') ||
          a.closest('.resource-card') ||
          a.closest('product-card') ||
          a.closest('.product-card') ||
          a.closest('li') ||
          a.closest('article');
        (card || a).style.display = 'none';
      });
    });
  }
  nukeProductLinks();

  // 4. Collapse grid columns when a hidden card leaves an empty slot.
  //    Horizon's product grids use explicit `grid-template-columns: 302px 302px ...`.
  //    Hiding a child via display:none doesn't shrink the column count, so the
  //    visible items reflow but leave empty trailing space (or, if the hidden
  //    item was in the middle, an empty middle column). We walk up from each
  //    hidden item to its grid container and rewrite grid-template-columns to
  //    contain exactly N tracks where N = number of still-visible children.
  function collapseGridColumns() {
    var grids = new Set();
    HIDDEN_HANDLES.forEach(function (h) {
      document.querySelectorAll('a[href*="/products/' + h + '"]').forEach(function (a) {
        // Skip cart-region matches
        if (a.closest('cart-drawer-component, cart-items-component, [class*="cart"]')) return;
        // Walk up to the first ancestor that is a CSS grid
        var el = a.parentElement;
        while (el && el !== document.body) {
          var d = getComputedStyle(el).display;
          if ((d === 'grid' || d === 'inline-grid') && el.children.length >= 2) {
            grids.add(el);
            break;
          }
          el = el.parentElement;
        }
      });
    });
    grids.forEach(function (grid) {
      var cs = getComputedStyle(grid);
      var tracks = (cs.gridTemplateColumns || '').trim().split(/\s+/);
      if (tracks.length < 2) return;
      var visibleChildren = Array.from(grid.children).filter(function (c) {
        return getComputedStyle(c).display !== 'none';
      });
      if (visibleChildren.length === 0 || visibleChildren.length >= tracks.length) return;
      // Use the first track's value as the canonical track size
      var trackSize = tracks[0];
      var newTpl = new Array(visibleChildren.length).fill(trackSize).join(' ');
      grid.style.setProperty('grid-template-columns', newTpl, 'important');
    });
  }
  collapseGridColumns();

  // 5. Re-run the link nuker AND grid collapser whenever the DOM changes
  //    (search dropdown opens, recommendations load, infinite scroll, etc.).
  var mo = new MutationObserver(function () {
    nukeProductLinks();
    collapseGridColumns();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

/* === Normalize product card image aspect ratio in collection/search grids ===
   Different products have source images with different natural aspect ratios.
   Horizon's slideshow-component uses aspect-ratio: auto by default, so a
   landscape source collapses the card height while a portrait source fills
   it — making cards visually misaligned in the same row. Force a consistent
   3/4 portrait ratio so every card in a grid has the same image height. */
(function () {
  if (document.getElementById('cs-card-aspect-fix')) return;
  var style = document.createElement('style');
  style.id = 'cs-card-aspect-fix';
  // Scope to .product-card > ... only (not inside quick-add dialogs).
  // quick-add-component's dialog is portaled and not a descendant of
  // .product-card, so excluding it via :not() also guards against any
  // accidental nesting.
  style.textContent =
    '.product-grid__item .product-card slideshow-component:not([slot]),' +
    '.product-grid__item .product-card .product-media {' +
    '  aspect-ratio: 3/4 !important;' +
    '  height: auto !important;' +
    '}' +
    '.product-grid__item .product-card .product-media__image {' +
    '  width: 100% !important;' +
    '  height: 100% !important;' +
    '  object-fit: cover !important;' +
    '}' +
    /* === Kill Horizon's quick-add button on grid cards ===
       It renders as a blank white rectangle on hover and the modal it
       opens is malformed (stacked images with whitespace). We don't want
       quick-add on product cards anywhere — users click through to PDP. */
    '.product-grid__item quick-add-component,' +
    '.resource-list__item quick-add-component,' +
    '.product-card quick-add-component,' +
    '.product-grid__item .quick-add,' +
    '.resource-list__item .quick-add,' +
    '.product-card .quick-add,' +
    '.product-grid__item .quick-add__button--choose,' +
    '.resource-list__item .quick-add__button--choose,' +
    '.product-card .quick-add__button--choose {' +
    '  display: none !important;' +
    '  visibility: hidden !important;' +
    '  pointer-events: none !important;' +
    '}';
  document.head.appendChild(style);
})();